<template>
	<div class="min-vh-100 pb-5">
		<div v-if="event">
		
			<div class="form-group">
				<label for="Immatriculation">{{$t('Registration')}} <span class="text-danger">*</span></label>
				<input ref="name" autocomplete="off" type="text" v-model="vehicle.name" class="form-control" id="Immatriculation" :class="{'is-invalid': errors.name}">
				<div class="invalid-feedback">
          {{$t('Enter the registration number')}}
				</div>
			</div>
			<div class="form-group">
				<label for="Type">{{$t('Type')}} <span class="text-danger">*</span></label>
				<select v-model="vehicle.type" class="form-control" id="Type" :class="{'is-invalid': errors.type}">
					<option v-for="t in config.parctypes" :value="t">{{t}}</option>
				</select>
				<div class="invalid-feedback">
          {{$t('Please choose the vehicle type')}}
				</div>
			</div>

			<a href="#" @click.prevent="cancel" class="btn btn-block btn-outline-primary mt-5">{{$t('Cancel')}}</a>
			<a href="#" @click.prevent="save" class="btn btn-block btn-primary mt-1">{{$t('saveButton')}}</a>
		</div>

        <br>
	</div>
</template>


<script>
	
	// @ is an alias to /src
	import {mapGetters, mapActions} from 'vuex'
	
	export default {
		name: 'vehicleform',
		props: ['eventid'],
		computed: {
			// mix the getters into computed with object spread operator
			...mapGetters('events', [
				'getEvent'
			]),
			...mapGetters('config', {'config': 'getConfig', 'getCalendrierId': 'getCalendrierId'}),
			...mapGetters('interventions', [
				'getIntervention'
			]),
		},
		beforeMount: function () {
			this.event = this.getEvent(this.eventid);
			this.intervention = this.getIntervention(this.eventid);
			this.initErrors();
			this.setPageTitle(this.event.client.name);
		},
		mounted(){
			this.$refs['name'].focus();
		},	
		data: function () {
			return {
				event: {},
				intervention: {},
				errors: {
					name: '',
					type: '',
				},
				vehicle: {
					name: '',
					type: '',
				},
			}
		},
        methods: {
			...mapActions('config', ['setPageTitle']),
			...mapActions('interventions', ['createVehicle']),
			initErrors (){
				this.errors.name = false;
				this.errors.type = false;
			},
			cancel(){
				if (confirm(this.$t('Are you sure you want to cancel this?'))){
					this.$router.push({name: 'vehicles', params:{eventid: this.eventid}});
				}
			},
			async save(){
				this.initErrors();
				let haserror = false;

				if (this.vehicle.name == '') {
					this.errors.name = true;
					this.haserror = true;
				} 
				if (this.vehicle.type == '') {
					this.errors.type = true;
					this.haserror = true;
				} 

				if (haserror) {
					return ;
				}

				await this.createVehicle({uid: this.eventid, data: this.vehicle}).then(()=> {
					this.$store.dispatch('events/refresh', this.getCalendrierId);
					this.$router.push({name: 'vehicles', params:{eventid: this.eventid}});
				}).catch((err) => {
					alert(this.$t('Please connect the photo for create the new vehicle'))
				})

			},
        }
	}
</script>
